import { DatePicker } from '@src/common/components/dates/DatePicker';
import { css } from '@src/common/styles/Styles';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> {
  control: Control<T>;
  fieldName: Path<T>;
  label?: string;
  readOnly?: boolean;
  disabled?: boolean;
  isUTC?: boolean;
  endAdornment?: JSX.Element;
}

export const FormDatePicker = <T extends FieldValues>({
  control,
  fieldName,
  label,
  readOnly,
  disabled,
  isUTC,
  endAdornment,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({
        field,
        fieldState: { error },
        formState: { disabled: formDisabled },
      }) => (
        <DatePicker
          key={field.value?.toString() ?? ''}
          {...field}
          readOnly={readOnly || formDisabled || disabled}
          value={field.value || null}
          className={fullWidth}
          label={label ?? t(`fields.${fieldName}`)}
          aria-label={t(`fields.${fieldName}`)}
          error={error && t(`formErrors.${error!.message}`)}
          isUTC={isUTC}
          endAdornment={endAdornment}
        />
      )}
    />
  );
};

const fullWidth = css({
  flex: 1,
});
